import { useRef } from 'react';
import styles from './DateSelect.module.scss';

const DatePickerForm = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled,
  placeholder = 'Select birthday',
  ...props
}) => {
  const inputRef = useRef(null);

  const handleContainerClick = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.showPicker?.();
      inputRef.current.focus();
    }
  };

  return (
    <div className={styles['input-container']} onClick={handleContainerClick}>
      {label && <label className={styles.label}>{label}</label>}

      <div
        className={`${styles['input-wrapper']} ${
          touched && error ? styles['input-error'] : ''
        }`}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <div className={styles['img-input-cont']}>
          <input
            ref={inputRef}
            type="date"
            name={name}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            disabled={disabled}
            max={new Date().toISOString().split('T')[0]}
            placeholder={placeholder}
            className={styles.input}
            {...props}
          />
        </div>
      </div>

      {touched && error && (
        <div className={styles['error-message']}>{error}</div>
      )}
    </div>
  );
};

export default DatePickerForm;
